import { GuideSection } from '@/components/guides/GuideSection';
import { GuideCallout } from '@/components/guides/GuideCallout';

export function AfterInterviewSection() {
  return (
    <GuideSection
      id="after-interview"
      eyebrow="Step 5"
      title="After the interview"
      description="What happens once you hit End session — and what your team does with the data."
    >
      <div className="space-y-3 text-sm text-muted-foreground">
        <p>
          When you click <strong>End session</strong>, NeuraX packages up the transcript (both your
          voice and the interviewer's) plus the coaching conversation and syncs it to your team's
          portal. Typical upload time is 30 to 60 seconds.
        </p>
        <p>
          Your recruiter uses this to give you <strong>specific feedback</strong> — which questions
          tripped you up, where you could have been clearer, what to drill before the next round.
          It's much more useful than "I think that went okay."
        </p>
        <p>
          You can close NeuraX right away; the sync happens in the background. Leave your laptop on
          for another minute if you're on a flaky connection.
        </p>
      </div>

      <GuideCallout variant="success" title="You're done">
        <p>
          That's the whole loop — install once, set up once, and from there every interview is just:
          open the app, check the mic, hit Start when the call begins, hit End when it ends.
          Everything else is automatic.
        </p>
      </GuideCallout>

      <GuideCallout variant="info" title="Data retention">
        <p>
          Transcripts live in your team's portal so they can coach you on subsequent rounds. You can
          ask your recruiter to delete a specific session's transcript at any time — it's your data.
        </p>
      </GuideCallout>
    </GuideSection>
  );
}
